<template>
  <div class="wrapper-page">

    <div class="card">
      <div class="card-block">

        <div class="ex-page-content text-center">
          <span><i class="fa fa-unlock-alt icon"></i></span>
          <h2 class="">Contenido Restringido</h2>
          <h5 class="text-muted">No tienes los permisos suficientes para ver este contenido.</h5>
          <router-link class="btn btn-primary mb-5 waves-effect waves-light go-home" to="/" href="#">Volver al Escritorio</router-link>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'restricted-content'
  }
</script>

<style scoped>
  .go-home {
    margin-top: 20px;
  }
  .icon {
    font-size: 47px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/RestrictedContentScreen.vue